
import Vue from "vue";
import { Subscription } from "../../models/payment/subscription";
import { AuthService } from "../../services/auth-service";
import { PaymentService } from "../../services/payment-service";
import { PriceFrequencyType } from "../../models/payment/pricing";
import { printLocalDate } from "../../utils/pretty-print";
import { HttpError } from "../../utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			subscription: null as Subscription | null,
			fetching: true,
			cancelModalOpened: false,
			passwordInput: ""
		};
	},
	computed: {
		shouldHaveSubscription():boolean {
			if (AuthService.wfCompany.isPermanentlyActive()){
				return false;
			}
			return true;
		},
		interval():string{
			if (!this.subscription){
				return "";
			}
			if (this.subscription.plan.paymentFrequency == PriceFrequencyType.QUARTER){
				return this.$ct("months", {amount: 3}).toString();
			}
			return this.$ct("year").toString();
		},
		showFrequencySwich():boolean {
			if (!this.subscription) return false;
			return this.subscription.plan.paymentFrequency != PriceFrequencyType.YEAR;
		}
	},
	methods: {
		async changeInterval(){
			if (!this.subscription) return;
			let plan = this.subscription.plan;
			if (plan.paymentFrequency == PriceFrequencyType.QUARTER){
				let confirmText = this.$ct("warning-can't-switch-back-frequency");
				let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(confirmText).show();
				if (!confirm) return;
				plan.paymentFrequency = PriceFrequencyType.YEAR;
			}else{
				return;
			}
			await PaymentService.changeFrequency(plan.paymentFrequency);
			this.subscription = await PaymentService.getActiveSubscription();
		},
		closeCancelModal(){
			this.passwordInput = "";
			this.cancelModalOpened = false;
		},
		openCancelModal(){
			this.passwordInput = "";
			this.cancelModalOpened = true;
		},
		async cancel(){
			await PaymentService.cancelSubscription(this.passwordInput);
			this.cancelModalOpened = false;
			this.passwordInput = "";
			this.subscription = null;
			let notifyText = this.$ct("cancelled.message", {activeUntil: printLocalDate(AuthService.wfCompany.ActiveUntil)}).toString();
			await this.$wf.dialog(notifyText, this.$ct("common.ok").toString(), this.$ct("cancelled.title"));
		}
	},
	async created(){
		if (this.shouldHaveSubscription){
			try{
				this.subscription = await PaymentService.getActiveSubscription();
			}catch(err){
				let error = err as HttpError;
				if (!error.isNetworkError){
					error.dontShow = true;
				}
			}
		}
		this.fetching = false;
	},
	i18nEx: {
		componentPrefix: "components.account.subscription"
	}
});
